import debug from 'debug';
const log = debug('QueryString');

export class QueryString {
	constructor() {
		this.parameters = this.Parameters();
	}

	Add(key, value) {
		if (typeof this.parameters === 'string') {
			this.parameters = [];
		}
		this.parameters[key] = value;
	}

	Get(key) {
		return this.parameters[key];
	}

	Parameters() {
		const search = window.location.search.substr(1).split('&');
		if (search == '') return '';

		let parameters = [];
		for (let i = 0; i < search.length; ++i)
		{
			var parameter = search[i].split('=', 2);
			if (parameter.length == 1)
				parameters[parameter[0]] = '';
			else
				parameters[parameter[0]] = decodeURIComponent(parameter[1].replace(/\+/g, " "));
		}
		return parameters;
	}

	Reload() {
		this.parameters = this.Parameters();
	}

	Remove(key) {
		delete this.parameters[key];
	}

	Reset() {
		this.parameters = [];
	}

	Search() {
		let parameter, search = [];
		for( parameter in this.parameters ) {
			search[search.length] = parameter + '=' + this.parameters[parameter];
		}
		return search.join( '&' );
	}
}

export let queryString = new QueryString();

